import React, {Component} from 'react';
import _ from 'lodash';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    Row,
    Popover,
    PopoverBody
} from 'reactstrap';
import PropTypes from 'prop-types';
import './RegisterOrg.css';
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import {Utils} from './../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import OrgPriceModal from './../orgPriceModal/OrgPriceModal.container';
import {
    EMPLOYEES_COUNT_VALUES,
    ORGANIZATION_AVAILABLE_FLAGS,
    FLAGS,
    ORGANIZATION_TYPES
} from './../../../constants/constants';
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Redirect} from 'react-router-dom';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import {EDU_ORG} from "../../../reducers/organization/organizations";
import DomainInput from "../../commonComponents/domainInput/DomainInput";

const REDIRECT_TO_LANDING_PAGE_ACTION_TYPE = 'redirect_to_landing_page_action_type';
const INVITE_NEXT_ACTION_TYPE = 'invite_next_action_type';

const requiredSelectFields = ['orgType', 'orgCountry'];

class RegisterOrg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgType: '',
            orgName: '',
            orgDomain: '',
            orgVatNumber: '',
            companyCode: '',
            orgContinent: this.props.continentCode,
            orgEmployeeCount: 'UNKNOWN',
            orgCountry: '',
            orgCity: '',
            orgPostal: '',
            orgStreet: '',
            orgStreetNumber: '',
            orgBusNumber: '',
            anchorFirstName: '',
            anchorLastName: '',
            anchorEmail: '',
            financialData: '',
            hasIVs: true,
            providesMoocCertificates: false,
            popoverOpen: null,
            actionType: null,
            redirect: false,
            requiredFieldError: null
        };
        this.resetData = this.resetData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.orgContinent !== nextProps.continentCode) {
            this.setState({orgContinent: nextProps.continentCode})
        }
        if (!this.props.success && nextProps.success) {
            this.resetData();
        }
    }

    componentWillUnmount() {
        this.props.onResetData();
        this.props.onContinentSet('');
    }

    render() {
        if (this.state.redirect && this.props.success) {
            return <Redirect to='/organizations'/>
        }

        return (
            <div className="register-anchor-org-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'register_org.success_message')}>
                    <BackButtonComponent path='/organizations'
                                         label={_.get(this.props.translation, 'edit_org.back_button')}/>
                    <div className="register-anchor-org-form">
                        <h4 className="page-label">{_.get(this.props.translation, 'register_org.register_org_label')}</h4>
                        <Form onSubmit={this.onSubmit}>
                            <h5 className="register-anchor-org-subtitle olive-green">{_.get(this.props.translation, sharedLabelsPath.org_label)}</h5>
                            {this.renderOrganizationDataFormGroups()}
                            <h6>{_.get(this.props.translation, 'orgs.address_label')}</h6>
                            {this.renderOrganizationAddressFormGroup()}
                            <h6 className='checkbox-group-label'>{_.get(this.props.translation, 'orgs.permissions_label')}</h6>
                            <div className='checkbox-group-container'>
                                {this.renderCheckboxes()}
                            </div>
                            <h5 className="register-anchor-org-subtitle olive-green">{_.get(this.props.translation, 'orgs.anchor_label')}</h5>
                            {this.renderAnchorFormGroups()}
                            <div className="buttons-group">
                                <Button type="submit" className="olive-green-btn invite-next-button"
                                        onClick={this.setActionType(INVITE_NEXT_ACTION_TYPE)}>{_.get(this.props.translation, 'register_org.invite_next_button')}</Button>
                                <Button type="submit"
                                        className="olive-green-btn"
                                        onClick={this.setActionType(REDIRECT_TO_LANDING_PAGE_ACTION_TYPE)}>{_.get(this.props.translation, 'register_org.send_invitation_button')}</Button>
                            </div>
                        </Form>
                    </div>
                </FormWrapper>
                <OrgPriceModal onSubmit={this.onSubmitModal}
                               submitButtonText={_.get(this.props.translation, 'finance.accept_price_and_send_invitation')}/>
            </div>
        );
    }

    renderOrganizationDataFormGroups = () => {
        let paramsList = [
            {
                value: "orgType",
                title: _.get(this.props.translation, 'orgs.org_type_label') + "*",
                type: 'select',
                content: Utils.getOptions(
                    _.map(ORGANIZATION_TYPES, value => ({
                        code: value.code,
                        name: _.get(this.props.translation, value.name)
                    }))
                ),
                placeholder: _.get(this.props.translation, 'register_org.org_type_placeholder'),
                isRequired: true,
                onChange: this.handleChangeOrgTypeSelect
            },
            {
                value: "orgName",
                title: _.get(this.props.translation, 'orgs.name_label') + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.name_label')
            },
            {
                value: "orgDomain",
                title: _.get(this.props.translation, sharedLabelsPath.domain_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.domain_label)
            },
            {
                value: "orgVatNumber",
                title: _.get(this.props.translation, 'orgs.vat_number_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.vat_number_label')
            },
            {
                value: "companyCode",
                title: _.get(this.props.translation, 'orgs.company_code_label'),
                isRequired: false,
                placeholder: _.get(this.props.translation, 'orgs.company_code_label')
            },
            {
                value: 'orgEmployeeCount',
                title: _.get(this.props.translation, sharedLabelsPath.employee_count_label),
                type: 'select',
                content: Utils.getOptions(_.map(EMPLOYEES_COUNT_VALUES, value => ({
                    code: value.code,
                    name: _.get(this.props.translation, value.name) || value.name
                }))),
                isRequired: true
            },
            {
                value: 'financialData',
                title: _.get(this.props.translation, 'orgs.financial_data_label') + "*",
                type: 'textarea',
                placeholder: _.get(this.props.translation, 'orgs.financial_data_placeholder'),
                isRequired: true
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderOrganizationAddressFormGroup = () => {
        let paramsList = [
            {
                value: "orgContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label) + "*",
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                onChange: this.handleChangeContinent,
                isRequired: true,
                isDisabled: !this.props.continents
            },
            {
                value: "orgCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label) + "*",
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isRequired: true,
                isDisabled: !this.props.countries
            },
            {
                value: "orgCity",
                title: _.get(this.props.translation, 'orgs.city_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.city_label')
            },
            {
                value: "orgPostal",
                title: _.get(this.props.translation, 'orgs.postal_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.postal_label')
            },
            {
                value: "orgStreet",
                title: _.get(this.props.translation, 'orgs.street_label') + '*',
                isRequired: true,
                placeholder: _.get(this.props.translation, 'orgs.street_label')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAnchorFormGroups = () => {
        let paramsList = [
            {
                value: "anchorEmail",
                title: _.get(this.props.translation, sharedLabelsPath.email_label) + "*",
                type: "email",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "anchorFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "anchorLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderCheckboxes = () => {
        return _.map(ORGANIZATION_AVAILABLE_FLAGS, flag => (
            <FormGroup key={flag} className='checkbox-form-group'>
                <Row className='checkbox-container'>
                    <Label className='checkbox-label'>
                        <Input type="checkbox" checked={this.state[flag]}
                               onChange={this.toggleCheckbox(flag)}/>
                        {_.get(this.props.translation, FLAGS[flag])}
                    </Label>
                </Row>
            </FormGroup>
        ))
    };

    getFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }

        if (params.value === 'orgDomain') {
            return this.getOrganizationDomainFormGroup(params);
        }

        if (params.type === 'select') {
            return this.getSelectFormGroup(params)
        }

        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder || params.title}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getOrganizationDomainFormGroup = (params) => {
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                {this.renderPopover(params)}
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <DomainInput id={id}
                                 value={this.state[params.value]}
                                 onChange={this.handleChangeDomainInput}
                                 placeholder={params.placeholder || params.title}
                                 disabled={params.isDisabled}
                                 required={params.isRequired}/>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderPopover = (params) => {
        let hintText = '';
        let id = 'register-org-by-anchor-';

        switch (params.value) {
            case 'orgDomain':
                id += 'domain-hint-container';
                hintText = _.get(this.props.translation, 'register_org.domain_hint');
                break;
            case 'companyCode':
                id += 'company-code-hint-container';
                hintText = _.get(this.props.translation, 'register_org.company_code_hint');
                break;
            case 'financialData':
                id += 'financial-data-container';
                hintText = [
                    <div key='part_1'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_1')}</div>,
                    <div key='part_2'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_2')}</div>,
                    <div key='part_3'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_3')}</div>
                ];
                break;
            default:
                return;
        }

        return (
            <div className="register-org-by-anchor-domain-hint-container">
                <span id={id} className='register-org-by-anchor-icon-container' onClick={this.togglePopover}>
                    <IconContainer icon='question_mark' title={_.get(this.props.translation, sharedLabelsPath.about_label)}/>
                </span>
                <Popover placement="bottom" isOpen={this.state.popoverOpen === params.value} target={id}
                         toggle={this.togglePopover(params.value)}>
                    <PopoverBody>
                        {hintText}
                    </PopoverBody>
                </Popover>
            </div>
        );
    };

    togglePopover = (type) => () => {
        if (this.state.popoverOpen === type) {
            this.setState({popoverOpen: null});
        } else {
            this.setState({popoverOpen: type});
        }
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeDomainInput = (data) => {
        this.setState({orgDomain: data});
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChangeOrgTypeSelect = (selectedOption) => {
        this.setState({
            orgType: selectedOption.value,
            hasIVs: selectedOption.value === EDU_ORG,
            providesMoocCertificates: false
        });
    };

    toggleCheckbox = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]})
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.setState({orgCountry: ''});
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        this.props.onShowFinance(this.state.orgType, this.state.orgCountry);
    };

    onSubmitModal = (priceData) => {
        let data = {
            type: this.state.orgType,
            name: this.state.orgName,
            domain: this.state.orgDomain,
            address: {
                countryCode: this.state.orgCountry,
                city: this.state.orgCity,
                postal: this.state.orgPostal,
                street: this.state.orgStreet
            },
            vatNumber: this.state.orgVatNumber,
            companyCode: this.state.companyCode,
            anchor: {
                email: this.state.anchorEmail,
                identityAlias: {
                    firstName: this.state.anchorFirstName,
                    lastName: this.state.anchorLastName,
                    countryCode: this.state.orgCountry
                }
            },
            hasIVs: this.state.hasIVs,
            verifiesIdentities: this.state.hasIVs,
            providesMoocCertificates: this.state.providesMoocCertificates,
            employeeCount: this.state.orgEmployeeCount,
            financialData: this.state.financialData,
            validated: true,
            ...priceData
        };

        this.props.onRegister(data);

        switch (this.state.actionType) {
            case REDIRECT_TO_LANDING_PAGE_ACTION_TYPE:
                this.setState({redirect: true});
                break;
            default:
                break;
        }
    };

    setActionType = (actionType) => () => {
        this.setState({actionType: actionType});
    };

    resetData() {
        this.setState({
            orgType: '',
            orgName: '',
            orgDomain: '',
            orgVatNumber: '',
            companyCode: '',
            orgContinent: this.props.continentCode,
            orgEmployeeCount: 'UNKNOWN',
            orgCountry: '',
            orgCity: '',
            orgPostal: '',
            orgStreet: '',
            orgStreetNumber: '',
            orgBusNumber: '',
            anchorFirstName: '',
            anchorLastName: '',
            anchorEmail: '',
            financialData: '',
            hasIVs: true,
            providesMoocCertificates: false,
            popoverOpen: null,
            actionType: null
        });
        this.props.onContinentSet('');
    }

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

RegisterOrg.propTypes = {
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    lastUsedContinent: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onShowFinance: PropTypes.func.isRequired,
    onRegister: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired,
    onResetData: PropTypes.func.isRequired
};

export default RegisterOrg;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/registerOrg/RegisterOrg.js